'use client';

import { memo } from 'react';
import { twMerge } from 'tailwind-merge';
interface ChatMessageProps {
  content: string;
  className?: string;
  ref?: React.RefObject<HTMLDivElement | null>;
}
export default memo(function UserChatMessage({
  className,
  content,
  ref
}: ChatMessageProps) {
  return <div ref={ref} className="group flex flex-col gap-1 max-w-4/5 self-end">
      <div className={twMerge('flex flex-col gap-3 rounded-lg py-2 px-3 bg-foreground text-background rounded-br-none mb-4', className)}>
        <div className="break-words text-[15px]">
          <p className="max-w-full whitespace-break-spaces">{content}</p>
        </div>
      </div>
    </div>;
});